import React, { useMemo } from 'react';

/**
 * Minimalist inline SVG sparkline. No deps. Dark-mode aware via currentColor.
 */
const Sparkline = ({
  data = [],
  width = 80,
  height = 24,
  stroke = 'currentColor',
  fill = 'none',
  strokeWidth = 1.5,
  showDot = true,
}) => {
  const path = useMemo(() => {
    if (!data || data.length < 2) return null;
    const values = data.map((d) => (typeof d === 'number' ? d : d?.value || 0));
    const min = Math.min(...values);
    const max = Math.max(...values);
    const range = max - min || 1;
    const stepX = width / (values.length - 1);
    const pts = values.map((v, i) => {
      const x = i * stepX;
      const y = height - ((v - min) / range) * (height - 4) - 2;
      return [x, y];
    });
    const d = pts.map(([x, y], i) => (i === 0 ? `M${x},${y}` : `L${x},${y}`)).join(' ');
    return { d, last: pts[pts.length - 1] };
  }, [data, width, height]);

  if (!path) {
    return (
      <svg width={width} height={height} className="opacity-40">
        <line x1={0} y1={height / 2} x2={width} y2={height / 2} stroke="currentColor" strokeDasharray="2 2" strokeWidth={1} />
      </svg>
    );
  }

  return (
    <svg width={width} height={height} viewBox={`0 0 ${width} ${height}`} aria-hidden>
      <path d={path.d} stroke={stroke} strokeWidth={strokeWidth} fill={fill} strokeLinecap="round" strokeLinejoin="round" />
      {showDot && (
        <circle cx={path.last[0]} cy={path.last[1]} r={2.5} fill={stroke} />
      )}
    </svg>
  );
};

export default Sparkline;
